export default __webpack_public_path__ + "static/media/welcome.6bad8900.png";